import React, { Component } from 'react'
import { connect } from 'react-redux';
import Link from 'next/link'
import { Trans, withTranslation } from 'react-i18next';
import { Layout, notification, Alert, Col, Row, Modal } from 'antd';
import { clearMessage, showOfflineMerge, hideOfflineMerge, setHeaderHeight } from '../../actions';
import Head from '../layout/head'
import Breadcrumb from '../layout/breadcrumb';
import UserBar from '../layout/user-bar';
import CatalogNavBar from '../catalog/catalog-nav-bar';
import ErrorBoundary from '../layout/ErrorBoundary'
import CatalogBanners from '../catalog/catalog-banners';
import CatalogOrderMergeModal from '../catalog/merge/catalog-order-merge-modal';
import getConfig from "next/config";
import { isSupportedBrowserVersion } from '../../Utils/getBrowserVersion';

const { Header, Footer, Content } = Layout;
const { publicRuntimeConfig: { fixHeaderMinBrowserVersions } } = getConfig();

class DefaultLayout extends Component {

    headerDivRef = React.createRef();
    state = { access: false }

    constructor(props) {
        super(props);
        this.resizeObserver = null;
        this.state = {
            supportedBrowserVersion: false
        };
    }

    componentDidMount() {
        const userAgent = window.navigator.userAgent;
        const supportedBrowserVersion = isSupportedBrowserVersion(userAgent, fixHeaderMinBrowserVersions);
        this.setState({ supportedBrowserVersion });

        if (supportedBrowserVersion){
            this.resizeObserver = new ResizeObserver(() => {
                this.headerHeightToState()
            });
        }

        if (this.headerDivRef.current && supportedBrowserVersion) {
            this.resizeObserver.observe(this.headerDivRef.current);
        }
    }

    componentWillUnmount() {
        if (this.resizeObserver && this.headerDivRef.current) {
            this.resizeObserver.unobserve(this.headerDivRef.current)
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.fixHeader !== prevProps.fixHeader) {
            this.headerHeightToState()
        }

        const { t, message, clearMessage } = this.props;
        if (message) {
            const translatedMessage = { ...message, message: t(message.message), description: t(message.description.statusCode ? message.description.message : message.description) }
            notification.open(translatedMessage);
            clearMessage();
        }
    }

    headerHeightToState= () => {
        const headerHeight = this.headerDivRef.current.offsetHeight;
        this.props.setHeaderHeight(headerHeight);
    }

    render() {
        const { t, children, bc, offline, ordersToMerge, showBanner, showCategories, showQuickCart, showEstimate, isMobile, headerHeight, fixHeader } = this.props;
        const { title = t("Iturria - Catalog"), hideBCTitle } = this.props;
        const ishide = (showCategories || showQuickCart || showEstimate);
        const { supportedBrowserVersion } = this.state;

        return (
            <Layout className="layout" style={{ height: "100vh" }}>

                {offline && <Alert message={t("Offline")} banner />}
                {!offline &&
                    ordersToMerge &&
                    (
                        ordersToMerge.pedidosToMerge.length > 0 || ordersToMerge.cotizaciontesToMerge.length > 0
                    ) &&
                    <a onClick={() => { this.props.showOfflineMerge() }}>
                        <Alert
                            message={t("Orders to merge")}
                            banner
                        />
                    </a>
                }

                <Modal
                    open={this.props.showOfflineMergeModal}
                    maskClosable={false}
                    closable={true}
                    wrapClassName="catalog-order-merge-modal"
                    footer={null}
                    width="90%"
                    title={
                        <div className="catalog-order-merge-title">
                            <span><Trans>Conflict Resolution</Trans></span>
                        </div>
                    }
                    onCancel={() => this.props.hideOfflineMerge()}
                >
                    <CatalogOrderMergeModal />
                </Modal>

                <Head title={title} />

                <div ref={this.headerDivRef} style={{ backgroundColor: '#fff' }} className={`${fixHeader ? 'fixed-header' : ''}`} >
                    <Header className={"hidden-print"} >
                        <Row>
                            <Col {...{ xs: { span: 12 }, md: { span: 4 } }}>
                                <Link href="/"><a className="logo"></a></Link>
                            </Col>
                            <Col {...{ xs: { span: 12 }, md: { span: 4, push: 16 } }}>
                                <UserBar />
                            </Col>
                            <Col {...{ xs: { span: 24 }, md: { span: 16, pull: 4 } }}>
                                {(!ishide || !isMobile) && showBanner && <CatalogBanners />}
                            </Col>
                        </Row>
                    </Header>

                    {(!ishide || !isMobile) && <CatalogNavBar supportedBrowserVersion={supportedBrowserVersion}/>}
                    {bc && (!ishide || !isMobile) && <Breadcrumb bc={bc} />}
                </div>

                <Content style={fixHeader ? { marginTop: headerHeight } : {}}>
                    <div>
                        <ErrorBoundary>
                            <div className={this.props.mainDivClassName}>
                                {this.props.title && !this.props.hideBCTitle &&
                                    <Row>
                                        <Col style={{ paddingLeft: '8px' }}><h2>{this.props.title}</h2></Col>
                                    </Row>
                                }
                                {children}
                            </div>
                        </ErrorBoundary>
                    </div>
                </Content>

                <Footer style={{ textAlign: 'center' }}><a href="http://www.iturria.com.ar" className={'hidden-print'} target="_blank" >{t("Iturria SA")}</a></Footer>

            </Layout>
        );
    }
}

const mapStateToProps = ({ common, catalog }) => {
    const { message, fixHeader, headerHeight  } = common;
    const { offline, ordersToMerge, showCategories, showQuickCart, showEstimate, showOfflineMerge } = catalog;
    const showOfflineMergeModal = showOfflineMerge
    return { message, offline, ordersToMerge, showCategories, showQuickCart, showEstimate, showOfflineMergeModal, fixHeader, headerHeight };
};

export default connect(mapStateToProps, { clearMessage, showOfflineMerge, hideOfflineMerge, setHeaderHeight })(withTranslation()(DefaultLayout));
